<template>
  <MRow :gutter="0" class="mt-4">
    <MCol :size="3">
      <FlotoStatusPicker
        :value="value.statusId"
        :module-name="$constants.ASSET_MOVEMENT"
        :placeholder="disabled ? '---' : undefined"
        disabled
        @change="handleChange({ statusId: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="$t('status')"
            icon-name="status"
            disabled
          />
        </template>
      </FlotoStatusPicker>
    </MCol>
    <MCol :size="3">
      <FlotoTriggerView
        icon-name="calendar-alt"
        :lable="`${$tc('movement')} ${$tc('date')}`"
        :value="
          !value.movementDate
            ? '---'
            : value.movementDate | datetime(undefined, false)
        "
      />
    </MCol>
    <MCol :size="3">
      <FlotoLocationPicker
        :value="value.fromLocation"
        :placeholder="disabled ? '---' : undefined"
        :disabled="fromLocationIsDisabled"
        :as-input="false"
        @change="handleChange({ fromLocation: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="`${$tc('from')} ${$tc('location')}`"
            icon-name="map-marker-alt"
            :disabled="fromLocationIsDisabled"
          />
        </template>
      </FlotoLocationPicker>
    </MCol>
    <MCol :size="3">
      <FlotoLocationPicker
        :value="value.toLocation"
        :placeholder="disabled ? '---' : undefined"
        :disabled="toLocationIsDisabled"
        :as-input="false"
        @change="handleChange({ toLocation: $event })"
      >
        <template v-slot:trigger="slotData">
          <FlotoDropdownTrigger
            v-bind="slotData"
            :lable="`${$tc('to')} ${$tc('location')}`"
            icon-name="map-marker-alt"
            :disabled="toLocationIsDisabled"
          />
        </template>
      </FlotoLocationPicker>
    </MCol>
  </MRow>
</template>
<script>
export default {
  name: 'PrimaryRow',
  model: {
    event: 'change',
  },
  props: {
    disabled: { type: Boolean, default: false },
    value: { type: Object, required: true },
    isDraft: { type: Boolean, defaul: false },
    isTransferReceived: { type: Boolean, defaul: false },
  },
  computed: {
    fromLocationIsDisabled() {
      if (this.value.movementType === 'send_to_repair') {
        return true
      }
      if (this.value.movementType === 'asset_transfer') {
        if (this.value.toLocation) {
          return this.disabled || !this.isDraft
        }
        return true
      }
      return this.disabled
    },
    toLocationIsDisabled() {
      if (this.value.movementType === 'return_from_repair') {
        return true
      }
      if (this.value.movementType === 'asset_transfer') {
        if (this.value.fromLocation) {
          return this.disabled || this.isTransferReceived
        }
        return true
      }
      return this.disabled
    },
  },
  methods: {
    handleChange(change) {
      this.$emit('change', change)
    },
  },
}
</script>
